/**
 * Full expert-app URL with `company_invite_error` (preserves expert session on :8081).
 */
export function buildExpertAppUrlWithCompanyInviteError(code: string): string {
  const rawBase = process.env.VUE_APP_EXPERT_APP_BASE_URL?.trim();
  const base = rawBase.endsWith("/") ? rawBase : `${rawBase}/`;
  try {
    const u = new URL(base);
    u.searchParams.set("company_invite_error", code);
    return u.toString();
  } catch {
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}company_invite_error=${encodeURIComponent(code)}`;
  }
}
